<template>
    <div
        class="kgr-card pointer"
        @click="openResultLink()"
    >
        <a
            v-if="!isFederation && resultLinkActive"
            :href="result.link"
            :aria-label="result.title"
            class="result-link"
            @click.stop
        ></a>
        <div class="kgr-card__image">
            <kgr-profile-image
                :src="result.image"
                :alt="result.title"
            />
        </div>
        <h4 class="kgr-card__name">
            <kgr-highlight
                :value="result.title"
                :search-phrase="searchPhrase"
            />
        </h4>
        <div class="kgr-card__contents">
            <p
                class="type"
                v-text="result.type"
            ></p>
            <p
                v-if="result.institutionName"
                v-text="result.institutionName"
            ></p>
            <p v-if="result.match">
                {{ result.match.key }}:
                <kgr-highlight
                    :value="result.match.value"
                    :search-phrase="searchPhrase"
                />
            </p>
            <p
                v-if="result.isKindergartenEmployee()"
                @mouseover="deactivateResultLink()"
                @mouseout="activateResultLink()"
            >
                <a
                    :href="employeeAbsenceUrl"
                    target="_blank"
                    class="kgr-link"
                >{{ $t('Abwesenheit erstellen') }}</a>
            </p>
        </div>
    </div>
</template>

<script>
import Highlight from '../../common/Highlight.vue';
import ProfileImage from '../../common/ProfileImage';
import Result from '../../../js/dto/livesearch/Result';

export default {
    components: {
        'kgr-highlight': Highlight,
        'kgr-profile-image': ProfileImage,
    },
    props: {
        resultData: {
            type: Object,
            required: true,
        },
        searchPhrase: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            result: new Result(),
            resultLinkActive: true,
        }
    },
    computed: {
        isFederation() {
            return document.location.pathname.startsWith('/federation');
        },
        employeeAbsenceUrl() {
            return `/federation/login/employee/${this.result.identity}/new-absence`;
        },
    },
    created() {
        this.result = Result.fromData(this.resultData);
    },
    methods: {
        openResultLink() {
            if (!this.resultLinkActive) {
                return;
            }
            window.location.href = this.result.link;
        },
        deactivateResultLink() {
            this.resultLinkActive = false;
        },
        activateResultLink() {
            this.resultLinkActive = true;
        },
    }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.result-link {
    position: absolute;
    display:block;
    inset:0;
    z-index:10;
}

.kgr-link{
    position:relative;
    z-index:20;
}

.pointer {
    cursor: pointer;
}
</style>
